import { render } from "./photo_admin_promote.vue?vue&type=template&id=4d2dff4c"
import script from "./photo_admin_promote.vue?vue&type=script&lang=js"
export * from "./photo_admin_promote.vue?vue&type=script&lang=js"

import "./photo_admin_promote.vue?vue&type=style&index=0&id=4d2dff4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__